import {
	Hand,
	HelpCircle,
	Sparkles,
	GitBranch,
	UserPlus,
	Star,
	PhoneForwarded,
	Flag,
} from "lucide-react";
import type { NodeType } from "@/lib/flow-types";
import { NODE_COLORS, NODE_LABELS } from "@/lib/flow-types";

const PALETTE_ITEMS: { type: NodeType; icon: React.ElementType; description: string }[] = [
	{ type: "greeting", icon: Hand, description: "Start the conversation" },
	{ type: "question", icon: HelpCircle, description: "Ask the visitor something" },
	{ type: "ai-response", icon: Sparkles, description: "AI-generated reply" },
	{ type: "condition", icon: GitBranch, description: "Branch the flow" },
	{ type: "lead-capture", icon: UserPlus, description: "Collect contact info" },
	{ type: "qualify", icon: Star, description: "Score the lead" },
	{ type: "handoff", icon: PhoneForwarded, description: "Transfer to human" },
	{ type: "end", icon: Flag, description: "End the chat" },
];

export function NodePalette() {
	const handleDragStart = (e: React.DragEvent, type: NodeType) => {
		e.dataTransfer.setData("application/chatconvert-node", type);
		e.dataTransfer.effectAllowed = "copy";
	};

	return (
		<div className="space-y-1.5">
			<h3 className="text-[11px] font-bold text-zinc-500 uppercase tracking-wider px-1 mb-3">
				Flow Steps
			</h3>
			{PALETTE_ITEMS.map(({ type, icon: Icon, description }) => {
				const color = NODE_COLORS[type];
				return (
					<div
						key={type}
						draggable
						onDragStart={(e) => handleDragStart(e, type)}
						className="flex items-center gap-2.5 px-2.5 py-2 rounded-lg cursor-grab active:cursor-grabbing hover:bg-white/[0.04] transition-colors group border border-transparent hover:border-white/[0.06]"
					>
						<div
							className="flex items-center justify-center w-8 h-8 rounded-lg shrink-0 transition-transform group-hover:scale-110"
							style={{ background: `${color}20` }}
						>
							<Icon
								size={16}
								style={{ color }}
								strokeWidth={2.5}
							/>
						</div>
						<div className="min-w-0">
							<p className="text-xs font-semibold text-zinc-300">
								{NODE_LABELS[type]}
							</p>
							<p className="text-[10px] text-zinc-500 truncate">
								{description}
							</p>
						</div>
					</div>
				);
			})}
			<div className="mt-3 px-2 py-2 rounded-lg bg-gradient-to-r from-indigo-500/10 to-purple-500/10 border border-indigo-500/15">
				<p className="text-[10px] text-indigo-400 font-medium">
					Drag steps onto the canvas to build your chatbot flow
				</p>
			</div>
		</div>
	);
}
